import * as _ from "lodash";

export class Publication {
    public constructor(public imageURL: string, public linkURL: string, public likes: number) {
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/publication.ts